<template>
    <div class="type-list">
        <ul>
            <li
                :class="{'active': currentIndex === index}"
                v-for="(item, index) in typeList"
                :key="index"
                @click="changeType(index)"
            >
                <div class="con">
                    <span class="tit">{{ item.name }}</span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        typeList: {
            type: Array,
        },
        resetIndex: {
            type: [String],
        },
    },
    data() {
        return {
            currentIndex: 0,
        };
    },
    watch: {
        resetIndex() {
            this.currentIndex = 0;
        },
    },
    methods: {
        changeType(index) {
            this.currentIndex = index;
            this.$emit('changeTable', index);
        },
    },
};
</script>
<style lang="stylus" scoped>
.type-list
    li
        position relative
        .con
            width 164px
            height 56px
            border 1px solid #D7D7D7
            text-align center
            position relative
            margin-bottom 20px
            overflow hidden
            cursor pointer
            .tit
                line-height 56px
                font-size 16px
            .status
                width 56px
                height 56px
                position absolute
                left -28px
                top -28px
                transform rotate(-45deg)
                -webkit-transform rotate(-45deg)
                -moz-transform rotate(-45deg)
                line-height 92px
                font-size 12px
                color #fff
        &.active
            background url('./../../../../assets/images/bbgl/frame_blue.png') no-repeat
            background-size 100% 100%
            .con
                border none
                color #5588f1
            // &:after
            //         content " "
            //         width 14px
            //         height 20px
            //         position absolute
            //         right: 2px;
            //         top 18px
            //         background url('./../../../../assets/images/bbgl/arrow_blue.png')
            //         background-size: 100% 100%;

</style>